import React, { Component } from "react";
import Drawer from "./drawerFilter";
import { Table, Empty, Pagination, Button } from "antd";
import { maskNcm, maskCest } from "../../../../../helpers/functions";

const initialState = {
  selectedPis: null,
  selectedIcms: null,
  filter: {
    sCodigoProduto: null,
    sDescricao: null,
    sNcm: null,
    sEx: null,
    sEan: null,
    sTributacao: null,
    sNumeroNota: null,
    sModelo: null,
    sDataEmissao: null,
    sCfop: null,
    sCst: null,
    sChave: null,
    sIndicadorOperacao: null,
    sSituacao: null,
    sQuantidade: null,
    sTotalBruto: null,
    sorter: null
  },
  dropdown: {
    vazioNcm: false,
    vazioCest: false
  }
};

class TableResults extends Component {
  constructor() {
    super();
    this.state = {
      ...initialState,
      sizePage: 50,
      paginationStr: "",
      sorterStr: "",
      filterStr: "",
      visibleDrawer: false,
      icmsModule: JSON.parse(sessionStorage.getItem("icmsModule"))
    };

    this.handleReset = this.handleReset.bind(this);
  }

  componentDidMount() {
    this.setState({
      paginationStr: `?pageNumber=1&pageSize=${this.state.sizePage}&filter=`
    });
  }

  changePage = page => {
    const { filterStr, sizePage } = this.state;

    this.setState(
      {
        paginationStr: `?pageNumber=${page}&pageSize=${sizePage}&filter=${filterStr}`
      },
      () => {
        this.props.action(this.props.period, this.state.paginationStr);
      }
    );
  };

  changeSizePage = (current, size) => {
    const { filterStr } = this.state;

    this.setState(
      {
        sizePage: size,
        paginationStr: `?pageNumber=${current}&pageSize=${size}&filter=${filterStr}`
      },
      () => {
        this.props.action(this.props.period, this.state.paginationStr);
      }
    );
  };

  handleFilters = () => {
    const { filter, sizePage } = this.state;
    let filterStr = "";

    filter['sTotalBruto'] = filter['sTotalBruto'] === '=' ? null : filter['sTotalBruto'];

    const handleReplace = (valor, item, subs) => {
      valor = valor.split(item).join(subs);
      return valor;
    };

    Object.keys(filter).map(item => {
      if (filter[item]) {
        const separador = filterStr ? "|" : "";
        if (item === 'sNcm') {
          const ncm = handleReplace(filter[item],'.','');
          filterStr = ncm !== '=' ? filterStr + separador + item + ncm : filterStr;
        } else if (item === 'sTotalBruto') {
          const valor = handleReplace(filter[item].replace('R$ ', ''), '.', '').replace(',', '.');
          filterStr = filterStr + separador + item + valor;
        } else if (item === 'sQuantidade') {
          const quantidade = parseFloat(filter[item].substr(1).replace(',', '.')).toFixed(4);
          if (!isNaN(quantidade)) {
            filterStr = filterStr + separador + item + '=' + quantidade;
          }
        } else if(item === 'sCst') {
          const cest = handleReplace(filter[item],'.','');
          filterStr = cest !== '=' ? filterStr + separador + item + cest : filterStr;
        } else {
          filterStr = filterStr + separador + item + filter[item];
        }
      }

      filterStr = filterStr.replace("sorter", "");
      return filterStr;
    });

    this.setState(
      {
        filterStr: filterStr,
        paginationStr: `?pageNumber=1&pageSize=${sizePage}&filter=`
      },
      () => {
        filterStr = this.state.paginationStr + filterStr;
        this.props.action(this.props.period, filterStr);
      }
    );
  };

  handleChangeSorter = (pagination, filters, sorter) => {
    const order = sorter.order === "ascend" ? 0 : 1;

    this.setState(
      {
        filter: {
          ...this.state.filter,
          sorter: sorter.field
            ? "o" + sorter.field.replace("Produto.", "") + "=" + order
            : ""
        }
      },
      () => {
        this.handleFilters();
      }
    );
  };

  handleChangeField = (e, field) => {
    let value = field ? e : e.target.value,
      name = field ? field : e.target.name,
      { year, month } = this.props.period;

    if (name === "DataEmissao") {
      if(value <= 0 ) { 
        value = 1;
      } else if(value >= 32) {
        value = 31;
      }

      this.setState({
        filter: {
          ...this.state.filter,
          ["s" + name]: value.length ? `=${year}-${month}-${value}` : null
        }
      });
    } else {
      this.setState({
        filter: {
          ...this.state.filter,
          ["s" + name]: value !== null ? `=${value}` : null
        }
      });
    }

    if (field === "DescricaoTributacaoPisCofins") {
      this.setState({ selectedPis: value });
    } else if (field === "DescricaoIcms") {
      this.setState({ selectedIcms: value });
    }
  };

  handleReset() {
    this.setState({ ...initialState });
  }

  showDrawer = () => {
    this.setState({ visibleDrawer: true });
  };

  onClose = () => {
    this.setState({ visibleDrawer: false });
  };

  render() {
    const { data, paging, period } = this.props;
    const { visibleDrawer, filterStr, icmsModule } = this.state;

    const columns = [
      {
        title: "Código do Item",
        dataIndex: "Produto.CodigoProduto",
        width: 150,
        sorter: true
      },
      {
        title: "Descrição",
        dataIndex: "Produto.Descricao",
        width: 420,
        sorter: true
      },
      {
        title: "NCM",
        dataIndex: "Produto.Ncm",
        width: 80,
        align: "center",
        sorter: true,
        render: (text, record) => maskNcm(record.Produto.Ncm)
      },
      {
        title: "EX",
        dataIndex: "Produto.Ex",
        width: 60,
        align: "center",
        sorter: true
      },
      {
        title: "EAN",
        dataIndex: "Produto.Ean",
        width: 120,
        align: "center",
        sorter: true
      },
      {
        title: "Tributação PIS/COFINS",
        dataIndex: "DescricaoTributacaoPisCofins",
        width: 200,
        sorter: true
      },
      {
        title: "Tributação ICMS",
        dataIndex: "DescricaoIcms",
        width: 200,
        sorter: true
      },
      {
        title: "Nº Documento Fiscal",
        dataIndex: "NumeroNota",
        width: 190,
        align: "center",
        sorter: true
      },
      {
        title: "Modelo",
        dataIndex: "Modelo",
        width: 95,
        align: "center",
        sorter: true
      },
      {
        title: "Data de Emissão",
        dataIndex: "DataEmissao",
        width: 150,
        align: "center",
        sorter: true
      },
      {
        title: "CFOP",
        dataIndex: "Cfop",
        width: 70,
        align: "center",
        sorter: true
      },
      {
        title: "CST ICMS",
        dataIndex: "Cst",
        width: 100,
        align: "center",
        sorter: true
      },
      {
        title: "CSOSN",
        dataIndex: "Csosn",
        width: 80,
        align: "center",
        sorter: true
      },
      {
        title: "Chave",
        dataIndex: "Chave",
        width: 350,
        align: "center",
        sorter: true
      },
      {
        title: "Indicador de Operação",
        dataIndex: "IndicadorOperacao",
        width: 190,
        align: "center",
        sorter: true
      },
      {
        title: "Situação do Documento",
        dataIndex: "Situacao",
        width: 200,
        align: "center",
        sorter: true
      },
      {
        title: "Quantidade",
        dataIndex: "Quantidade",
        width: 120,
        align: "center",
        sorter: true
      },
      {
        title: "Desconto",
        dataIndex: "TotalDesconto",
        width: 120,
        align: "right",
        sorter: true
      },
      {
        title: "Valor de Frete",
        dataIndex: "TotalFrete",
        width: 120,
        align: "right",
        sorter: true
      },
      {
        title: "Valor de acréscimo",
        dataIndex: "ValorAcrescido",
        width: 120,
        align: "right",
        sorter: true
      },
      {
        title: "Valor de outros",
        dataIndex: "ValorOutrasDespesas",
        width: 120,
        align: "right",
        sorter: true
      },
      {
        title: "Valor",
        dataIndex: "TotalBruto",
        width: 120,
        align: "right",
        sorter: true
      }
    ];

    if (icmsModule) {
      columns.splice(4, 0, {
        title: "CEST",
        dataIndex: "Produto.Cest",
        width: 80,
        align: "center",
        sorter: true,
        render: (text, record) => maskCest(record.Produto.Cest)
      });
    }

    return (
      <>
        {visibleDrawer ? (
          <Drawer
            {...this.state}
            visibleDrawer={visibleDrawer}
            handleChangeField={this.handleChangeField}
            handleFilters={this.handleFilters}
            handleReset={this.handleReset}
            onClose={this.onClose}
            period={period}
          />
        ) : null}

        {data.length ? (
          <>
            <div className="d-flex justify-content-end pb-2">
              <Button
                className="bg-transparent"
                icon="filter"
                onClick={this.showDrawer}
              >
                Filtrar
              </Button>
            </div>

            <Table
              className="ant-table--custom"
              dataSource={data}
              rowKey={record => record.Id}
              columns={columns}
              scroll={{
                x: 3350,
                y: "calc(100vh - 355px)"
              }}
              pagination={false}
              onChange={this.handleChangeSorter}
            />

            {(paging ? <Pagination
              className="my-3"
              showSizeChanger
              pageSizeOptions={["10", "50", "100"]}
              defaultPageSize={50}
              defaultCurrent={1}
              total={paging && paging.TotalItems}
              showTotal={(total, range) =>
                `${range[0]}-${range[1]} de ${total} itens`
              }
              onChange={this.changePage}
              onShowSizeChange={this.changeSizePage}
            /> : null)}

          </>
        ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Nenhum produto para mostrar"
            >
              {filterStr !== "" ? (
                <Button className="btn" icon="filter" onClick={this.showDrawer}>
                  Filtrar
              </Button>
              ) : null}
            </Empty>
          )}
      </>
    );
  }
}

export default TableResults;
